<div class="body-app my-4">
    <div class="content-app">
        <div class="row mb-5">
            <div class="col-12 mb-4">
                <h3 class="section-title">
                    <i class="fa-solid fa-magnifying-glass me-2 text-primary"></i>
                    Buscar Ofertas Laborales
                </h3>
            </div>
            <div class="col-12">
                <div class="card rounded-4 shadow-sm border-0 mb-5">
                    <div class="card-body p-4">
                        <!-- Search box -->
                        <div class="row mb-4">
                            <div class="col-md-12">
                                <div class="input-group">
                                    <input type="text" class="form-control rounded-start" placeholder="Buscar por título o descripción" [(ngModel)]="searchText" (keyup.enter)="onSearch()">
                                    <button class="btn btn-primary rounded-end" type="button" (click)="onSearch()">
                                        <i class="fa-solid fa-magnifying-glass"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Dropdown filters -->
                        <div class="row mb-4">
                            <div class="col-md-4 mb-3">
                                <label class="form-label fw-medium text-secondary small">Provincia</label>
                                <app-dropdown [options]="provinces" [(ngModel)]="filter.stateId"></app-dropdown>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label fw-medium text-secondary small">Departamento</label>
                                <app-dropdown [options]="departments" [(ngModel)]="filter.departmentId"></app-dropdown>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label fw-medium text-secondary small">Posición</label>
                                <app-dropdown [options]="positions" [(ngModel)]="filter.positionId"></app-dropdown>
                            </div>
                        </div>
                        
                        <!-- Action buttons -->
                        <div class="row">
                            <div class="col-md-12 d-flex justify-content-end">
                                <button class="btn btn-outline-secondary me-2 rounded-pill" (click)="clearFilters()">
                                    <i class="fa-solid fa-broom me-1"></i> Limpiar filtros
                                </button>
                                <button class="btn btn-primary rounded-pill" (click)="onSearch()">
                                    <i class="fa-solid fa-magnifying-glass me-1"></i> Buscar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Job Offers List -->
        <div class="row mb-4">
            <div class="col-12 mb-4">
                <h3 class="section-title">
                    <i class="fa-solid fa-briefcase me-2 text-primary"></i>
                    Resultados
                </h3>
            </div>
            <div class="col-12">
                <!-- Loading indicator -->
                @if (isLoading()) {
                    <div class="d-flex justify-content-center">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Cargando...</span>
                        </div>
                    </div>
                } @else {
                    <!-- No results message -->
                    @if (jobOffers().length === 0) {
                        <div class="alert alert-info text-center rounded-4">
                            <i class="fa-solid fa-info-circle me-2"></i> No se encontraron ofertas laborales con los criterios de búsqueda seleccionados.
                        </div>
                    }
                    
                    <!-- Login message for non-authenticated users -->
                    <!-- @if (!isUserLoggedIn() && jobOffers().length > 0) {
                        <div class="alert alert-info text-center rounded-4 mb-3">
                            <i class="fa-solid fa-info-circle me-2"></i>
                            <strong>Información privada:</strong> Inicia sesión para ver los detalles completos de las empresas y más ofertas laborales.
                        </div>
                    } -->

                    <!-- Job Offers List -->
                    <div class="card rounded-4 mb-3 border-0">
                        <div class="card-body p-0">
                            <ul class="list-group" [ngClass]="{'list-container-scroll': jobOffers().length > 5}">
                                <li class="list-group-item list-group-item-job" *ngFor="let item of jobOffers()">
                                    <div class="row align-items-center">
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-4" [routerLink]="['/home','job',item.id]" style="cursor: pointer;">
                                            @if(!isUserLoggedIn()) {
                                                <img src="assets/Images/logo-compania.jpg" alt="Logo" class="img-fluid logo-company" />
                                            } @else if(item.logoUrl) {
                                                <img [src]="item.logoUrl" alt="Logo" class="img-fluid logo-company" 
                                                    onerror="this.error=null; this.src='assets/Images/logo-compania.jpg'" />
                                            } @else {
                                                <img src="assets/Images/logo-compania.jpg" alt="Logo" class="img-fluid logo-company" />
                                            }
                                        </div>
                                        <div class="col-xl-10 col-lg-10 col-md-10 col-sm-9 col-8">
                                            <div class="d-flex align-items-center mb-1">
                                                <a [routerLink]="['/home','job',item.id]" class="text-decoration-none fs-5 fw-bold mt-0 mb-0 d-block">
                                                    {{ item.title }}
                                                </a>
                                                <!-- Badge de vistas -->
                                                <span class="badge bg-light text-dark ms-2 d-flex align-items-center">
                                                    <i class="fa-regular fa-eye me-1"></i>
                                                    {{ getViewCount(item.id) }}
                                                </span>
                                            </div>
                                            <div class="d-flex align-items-center mb-2">
                                                <i class="fa-regular fa-building text-primary me-1"></i>
                                                <a [routerLink]="['/home','job',item.id]" class="text-decoration-none text-muted">
                                                    @if(!isUserLoggedIn()) {
                                                        <span class="private-info">Información privada (Inicia sesión para ver)</span>
                                                    } @else {
                                                        {{ item.ownerFullName }}
                                                    }
                                                </a>
                                            </div>
                                            <p class="mt-0 mb-3 text-secondary">
                                                {{ item.description }}
                                            </p>
                                            <div class="row">
                                                <div class="col-md-4 col-sm-6 col-12 mb-2">
                                                    <div class="d-flex align-items-center">
                                                        <div class="icon-bg me-2">
                                                            <i class="fa-regular fa-clock text-primary"></i>
                                                        </div>
                                                        <div>
                                                            <label class="fw-bold d-block mb-0 small text-secondary">Duración del Contrato</label>
                                                            <span>{{ item.contractDurationName || 'No especificado' }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4 col-sm-6 col-12 mb-2">
                                                    <div class="d-flex align-items-center">
                                                        <div class="icon-bg me-2">
                                                            <i class="fa-regular fa-calendar text-primary"></i>
                                                        </div>
                                                        <div>
                                                            <label class="fw-bold d-block mb-0 small text-secondary">Fecha de Publicación</label>
                                                            <span>{{ item.publicOn ? (item.publicOn | date : 'dd/MM/yyyy') : 'No especificado' }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4 col-sm-6 col-12 mb-2">
                                                    <div class="d-flex align-items-center">
                                                        <div class="icon-bg me-2">
                                                            <i class="fa-solid fa-location-dot text-primary"></i>
                                                        </div>
                                                        <div>
                                                            <label class="fw-bold d-block mb-0 small text-secondary">Ubicación</label>
                                                            <span>
                                                                <span *ngIf="item.countryName">{{ item.countryName }}</span>
                                                                <span *ngIf="item.stateName"> / {{ item.stateName }}</span>
                                                                <span *ngIf="item.cityName"> / {{ item.cityName }}</span>
                                                                <span *ngIf="!item.countryName && !item.stateName && !item.cityName">No especificado</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="d-flex justify-content-end mt-3">
                                                <a [routerLink]="['/home','job',item.id]" class="btn btn-primary btn-sm rounded-pill">
                                                    <i class="fa-solid fa-eye me-1"></i> Ver detalles
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- Pagination -->
                    @if (totalItems > 0) {
                        <app-pagination 
                            class="mt-4" 
                            [page]="page" 
                            [pageSize]="pageSize" 
                            [totalItems]="totalItems" 
                            (pageChange)="onPageChange($event)" 
                            (pageSizeChange)="onPageSizeChange($event)">
                        </app-pagination>
                    }
                }
            </div>
        </div>
    </div>
</div>
